module.exports = __webpack_public_path__ + "static/media/icon_qr_scan_button_close.1014a86b.png";